import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import { Toaster } from "@/components/ui/sonner";
import { queryClient } from "@/lib/query-client";

import type { ReactNode } from "react";

type AppProvidersProps = {
  readonly children: ReactNode;
};

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {/* Top offsets keep toasts below the header buttons in DashboardLayout. */}
      <Toaster mobileOffset={{ top: 68 }} offset={{ top: 84 }} position="top-right" />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
